
import './App.css';
import { Header,Container,Who, What,Contact,Activities,Footer,Goals} from './Sections/index'

function App() {
  return (
   <>
   <Header/>
   <Container/>
   <Who/>
   <Contact/>
   <What/>
   <Goals/>
   <Activities/>
   <Footer/>
   
   </>
  );
}

export default App;
